module.exports = __webpack_public_path__ + "img/avatar04.ba98dcc0.jpg";